import React, { forwardRef } from 'react';

interface ShareProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const Share = forwardRef<HTMLElement, ShareProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-regular fa-share-from-square ${classes || ''}`} style={style}></i>
  );
});

Share.displayName = 'Share';
